export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8668.2295eb34.jpg";